<mat-select
  [value]="i18n.currentLang()"
  (valueChange)="onLanguageChange($event)"
  class="language-selector"
  panelClass="language-selector-panel"
  aria-label="Select language"
  panelWidth="null"
>
  <mat-select-trigger class="language-select-trigger">
    <mat-icon class="language-icon">language</mat-icon>
    @if (selectedLanguageLabelKey(); as labelKey) {
      <span class="language-label">{{ labelKey | translate }}</span>
    }
  </mat-select-trigger>
  @for (lang of i18n.supportedLanguages; track lang.code) {
    <mat-option class="selector-option" [value]="lang.code">
      {{ lang.labelKey | translate }}
    </mat-option>
  }
</mat-select>
